import randomBytes from 'randombytes';
class UniqueUserId {
    constructor() {
        var _a;
        this.id = (_a = localStorage.getItem(UniqueUserId.localStorageId)) !== null && _a !== void 0 ? _a : this.generateId();
        localStorage.setItem(UniqueUserId.localStorageId, this.id);
    }
    generateId() {
        return randomBytes(16).toString('base64');
    }
    toString() {
        return this.id;
    }
}
UniqueUserId.localStorageId = '_coin_cid';
export default UniqueUserId;
//# sourceMappingURL=UniqueUserId.js.map